// First-run onboarding / coach marks / "remember where you parked" prompt state.
// Device-local only (no accounts yet).

const ONBOARDING_KEY = "spotdrop_onboarding_seen";
const COACHMARKS_KEY = "spotdrop_coachmarks_seen";
const PROMPT_KEY = "spotdrop_park_prompt_v1";
const PROMPT_SESSION_FLAG = "spotdrop_park_prompt_session";

const HOUR = 60 * 60 * 1000;

const read = (k) => {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, v);
  } catch {
    /* ignore */
  }
};

export const onboardingSeen = () => read(ONBOARDING_KEY) === "1";
export const markOnboardingSeen = () => write(ONBOARDING_KEY, "1");

export const coachMarksSeen = () => read(COACHMARKS_KEY) === "1";
export const markCoachMarksSeen = () => write(COACHMARKS_KEY, "1");

function promptState() {
  try {
    const s = JSON.parse(read(PROMPT_KEY) || "{}");
    return { lastShown: s.lastShown || 0, dismissals: s.dismissals || 0 };
  } catch {
    return { lastShown: 0, dismissals: 0 };
  }
}

function savePromptState(s) {
  write(PROMPT_KEY, JSON.stringify(s));
}

/** Max once per session, ≥4 h apart; 24 h after 2 dismissals; never after 4. */
export function canShowParkingPrompt() {
  const { lastShown, dismissals } = promptState();
  if (dismissals >= 4) return false;
  try {
    if (sessionStorage.getItem(PROMPT_SESSION_FLAG)) return false;
  } catch {
    /* ignore */
  }
  const cooldown = dismissals >= 2 ? 24 * HOUR : 4 * HOUR;
  return Date.now() - lastShown >= cooldown;
}

export function markParkingPromptShown() {
  const s = promptState();
  savePromptState({ ...s, lastShown: Date.now() });
  try {
    sessionStorage.setItem(PROMPT_SESSION_FLAG, "1");
  } catch {
    /* ignore */
  }
}

export function markParkingPromptDismissed() {
  const s = promptState();
  savePromptState({ lastShown: Date.now(), dismissals: s.dismissals + 1 });
}

export function markParkingPromptAccepted() {
  savePromptState({ lastShown: Date.now(), dismissals: 0 });
}
